<ng-container *ngIf="model">
  <div
    [dragAndDrop]="dragData"
    class="tag"
    [escape]="false"
    [pTooltip]="tooltipText"
    tooltipPosition="bottom"
    tooltipStyleClass="u-tooltip"
    [class.show-copied]="showCopied"
    [class.no-text]="!model.text"
    [style.backgroundColor]="model.backgroundColor"
    [style.color]="model.textColor"
    [ngClass]="{ 'default-bg': !model.backgroundColor }"
  >
    <u-icon *ngIf="model.icon" [model]="iconModel" class="icon"></u-icon>
    <span *ngIf="model.caption">{{ model.caption }}:&nbsp;</span>
    <span *ngIf="model.text" [ngStyle]="{ color: model.textColor }" class="text" #wrapperContainer>
      <span #tag>
        {{ model.text }}
      </span>
    </span>
    <span [class.copy-icon]="model.icon && showCopied" class="copy-ind">Copied</span>
  </div>
</ng-container>
